import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react'
import { cn } from '@/lib/utils'

export type SortDirection = 'asc' | 'desc' | null

interface SortableThProps {
  label: string
  sortKey: string
  currentSort: string | null
  currentDirection: SortDirection
  onSort: (key: string) => void
  className?: string
}

export function SortableTh({ label, sortKey, currentSort, currentDirection, onSort, className }: SortableThProps) {
  const isActive = currentSort === sortKey

  return (
    <th
      className={cn(
        'cursor-pointer select-none px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider transition-colors',
        isActive
          ? 'text-primary'
          : 'text-neutral-500 hover:text-neutral-700',
        className,
      )}
      onClick={() => onSort(sortKey)}
    >
      <span className="inline-flex items-center gap-1.5">
        {label}
        {isActive ? (
          currentDirection === 'asc' ? (
            <ArrowUp className="h-3.5 w-3.5" />
          ) : (
            <ArrowDown className="h-3.5 w-3.5" />
          )
        ) : (
          <ArrowUpDown className="h-3 w-3 text-neutral-300" />
        )}
      </span>
    </th>
  )
}
